import CardWithFields from "components/General/CardWithFields";
import { getName } from "js/formatting";
import { useTranslation } from "react-i18next";

export default function AnnuitantCard({ annuitants, policy }) {
  const { t } = useTranslation();
  const primaryAnnuitants = annuitants.filter(
    (a) => a?.person?.partyTypeCode === "IN"
  );
  const jointAnnuitants = annuitants.filter(
    (a) => a?.person?.partyTypeCode !== "IN"
  );

  const renderAnnuitants = (list, showIssueAge) =>
    list.reduce((fields, currentAnnuitant) => {
      return [
        ...fields,
        {
          title: t("CustomerPolicyDetails-annuity-insured-name"),
          value: getName(currentAnnuitant?.person),
        },
        {
          title: t("CustomerPolicyDetails-annuity-insured-dob"),
          value: currentAnnuitant?.person.dateofBirth,
        },
        ...(showIssueAge
          ? [
              {
                title: t("CustomerPolicyDetails-annuity-insured-issue-age"),
                value: policy?.insuredIssueAge,
              },
            ]
          : []),
        {
          title: "", // created empty div. don't remove it.
          value: "", // created empty div. don't remove it.
        },
      ];
    }, []);

  const cardFields = [
    ...(primaryAnnuitants.length > 0
      ? renderAnnuitants(primaryAnnuitants, true)
      : []),
    ...(jointAnnuitants.length > 0
      ? renderAnnuitants(jointAnnuitants, false)
      : []),
  ];

  return (
    <CardWithFields
      ariaLabel={t("CustomerPolicyDetails-annuity-insured-aria-label")}
      cardTitle={t("CustomerPolicyDetails-annuity-insured-card-title")}
      cardFields={cardFields}
    />
  );
}
